import { Pipe, PipeTransform } from '@angular/core';

import { RDS_TEXT_PARAMETER_OPTIONS, RdsTextParameterOption } from './text-filter.model';

/**
 * Sorts parameter options to match the order of `RDS_TEXT_PARAMETER_OPTIONS`
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsSortTextParameterOption',
})
export class RdsSortTextParameterOptionsPipe implements PipeTransform {
  transform(options: Array<RdsTextParameterOption> | null | undefined): Array<RdsTextParameterOption> {
    if (!options?.length) {
      return [];
    }
    return options.sort(
      (a, b) =>
        RDS_TEXT_PARAMETER_OPTIONS.findIndex((f) => f.type === a.type) - RDS_TEXT_PARAMETER_OPTIONS.findIndex((f) => f.type === b.type)
    );
  }
}
